<template>
	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-bind:style="{ width: screenWidth+'px', height: screenHeight + 'px' }" v-show="pop_show">
		<span class="pop_bg" @click="closeshow()"></span>

		<div id="pop_bodyup" class="pop_content">
			<!-- 动态查询区生成 -->
			<div class="pop_children">
				<div class="pop_head_close">
					<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
				</div>
				<div>
					<h5>{{sheet_no}}&nbsp;&nbsp;违章登记同步:</h5>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="refresh_data()">
							刷新
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('new')">
							新增
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('add')">
							保存
						</button>&nbsp;
						<button class="pre_btn_ok btn_del" @click="fun_upd('del')">
							删除
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('sub')">
							提交
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('bad')">
							作废
						</button>&nbsp;
					</div>
					<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
						<h3 class="red">
							{{sheet_flag}}
						</h3>
					</div>
				</div>

				<div class="content_edit edit-body">
					<div class="content_edit_item tab-border">
						<div class="content_edit_item tab-row">录入违章</div>
						<div id="pre_tab" class="content_edit_item tab-row">
							<table class="pre_view_tab" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header">
									<td>序号</td>
									<td>发生日期</td>
									<td>罚款</td>
									<td>备注</td>
									<td class="short cen">操作</td>
								</tr>
								<tr class="tab-body" :id="'tan_'+item.row_num" v-for="item in list_wz"
									@click="fun_d1_sel(item)">
									<!-- <a href="#"> -->
									<td>{{item.row_num}}</td>
									<td>{{item.c_date}}</td>
									<td>{{item.c_amount}}</td>
									<td v-on:mousemove="show_detaildata($event, item.note, '1')"
										v-on:mouseout="noshow_detaildata">
										<a href="#">{{item.note}}</a>
									</td>
									<td class="short cen">
										<span @click="fun_d1_upd('_del',item)">
											<i class="iconfont icon-shanchu"></i>删除
										</span>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="content_edit_item tab-border">
						<div class="content_edit_item edit-row" v-for="(r,d) in max_row" :key="d">

							<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm"
								:key="index">
								<!-- {{handleImportView(item)}} -->

								<component ref="editfatherzj" :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_edit">
								</component>
							</div>
						</div>

						<div class="content_edit" v-show="file_show">
							<div class="content_edit_item">
								<label>文件:</label><span>{{file_name}}&nbsp;&nbsp;</span>
							</div>
						</div>
					</div>

				</div>



			</div>
		</div>
		<div id="pre_msg_data_wz" style="display:none;"></div>

	</div>
</template>

<script>
	/* 
	维修弹窗。。。。。。。
	*/
	import api from '@/utils/type.js';
	import {
		Select_PageLengthMore,
		Method_CommonLong,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import {
		JsonStr
	} from '@/utils/method.js';
	import {
		GetShort,
		BackSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	
	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete,
		ReplaceAll
	} from '@/utils/method.js';

	export default {
		name: "pre_tan_car_wz",
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				row_id: '',
				sys_date: '',
				sheet_no: '',
				sheet_flag: '',
				screenWidth: '',
				screenHeight: '',
				sel_action: '',
				upd_action: '',

				max_row: [],
				list_m: '',
				parm: [],
				sheet_wx: '',

				file_show: false,
				file_name: '',

				list_wz: [],




			};
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			chang_style: function() {
				this.screenWidth = $(window).width();
				this.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
			},
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
				this.chang_style();
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			load_data: async function(res) {
				// console.log('初始参数', res);

				let r = res;
				// 清理缓存
				this.row_id = '';
				this.sel_action = 'exp_carViol';
				this.upd_action = 'car_carViolation';

				this.title = '';
				this.sheet_no = r.sheet_no;
				this.sheet_wx = '';
				// this.sheet_flag=r.flag;
				this.parm = []; //主单保存数据
				this.parm = [{
						"name": "单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"x": "1",
						"r": "1"
					},
					{
						"name": "车牌号码",
						"val": "",
						"key": "c_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "1",
						"x": "1"
					},
					{
						"name": "车挂别名",
						"val": "",
						"key": "cp_no",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_car_bm",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "汽车分类",
						"val": "",
						"key": "carclass",
						"type": "text",
						"class": "long1",
						"p": "0",
						"w": "0",
						"x": "1",
						"r": "1"
					},
					{
						"name": "罚单编号",
						"val": "",
						"key": "c_name",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "违章日期",
						"val": "",
						"key": "c_date",
						"type": "datetime",
						"class": "long2",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},

					{
						"name": "司机",
						"val": "",
						"key": "c_driver",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "跟车员",
						"val": "",
						"key": "c_tail",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "货物名称",
						"val": "",
						"key": "c_thing",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "违章地点",
						"val": "",
						"key": "c_addr",
						"type": "text",
						"class": "long2",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "3"
					},
					{
						"name": "违章详情",
						"val": "",
						"key": "c_data",
						"type": "text",
						"class": "long3",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "3"
					},
					{
						"name": "扣分",
						"val": "0",
						"key": "c_num",
						"type": "number",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "4"
					},
					{
						"name": "罚款金额",
						"val": "0",
						"key": "v_fee",
						"type": "number",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "4"
					},
					{
						"name": "消分费用",
						"val": "0",
						"key": "v_fee_num",
						"type": "number",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "4"
					},
					{
						"name": "滞纳金",
						"val": "0",
						"key": "v_fee_late",
						"type": "number",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "4"
					},
					{
						"name": "总费用",
						"val": "",
						"key": "c_amount",
						"type": "text",
						"class": "long1",
						"p": "0",
						"w": "0",
						"r": "0",
						"x": "5"
					},
					{
						"name": "司机承担",
						"val": "",
						"key": "v_fee_user",
						"type": "number",
						"class": "long1",
						"note": "司机承担费用",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "5"
					},
					{
						"name": "处理结果",
						"val": "1",
						"key": "v_flag",
						"type": "none",
						"list": [{
							"id": "1",
							"val": "待处理"
						}, {
							"id": "2",
							"val": "已消除"
						}],
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "5"
					},

					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "6"
					},
					{
						"name": "经办人",
						"val": "",
						"key": "u_name",
						"type": "select",
						"class": "long1",
						"sel_action": "data_alluser",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "6"

					}
				];

				/*初始化 select 数据 start*/


				for (let i = 0; i < this.parm.length; i++) {
					switch (this.parm[i].type) {
						case 'select':
							let t = [];
							let t_sel_action = '';
							t_sel_action = this.parm[i].sel_action;
							if (typeof(t_sel_action) !== 'undefined' && t_sel_action != '') {
								let res = await this.loadClass(t_sel_action);
								if (res.status == '1') {
									t = res.data;
									this.parm[i].list = t;
								}
								// console.log(res);

							}
							break;
						case 'switch':
							let t_in_action = '',
								t_out_action = '';
							t_in_action = this.parm[i].action_in;
							t_out_action = this.parm[i].action_out;
							if (typeof(t_in_action) !== 'undefined' && t_in_action != '') {
								let res_in = await this.loadClass(t_in_action);
								// console.log('收入', res_in);
								if (res_in.status == '1') {
									this.parm[i].list_in = res_in.data;
								} else {
									this.parm[i].list_in = [];
								}
							}

							if (typeof(t_out_action) !== 'undefined' && t_out_action != '') {
								let res_out = await this.loadClass(t_out_action);
								// console.log('支出', res_out)
								if (res_out.status == '1') {
									this.parm[i].list_out = res_out.data;
								} else {
									this.parm[i].list_out = [];
								}
							}

							break;
					}

				}
				this.max_row = [];
				for (let i = 1; i <= this.parm.length; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.refresh_data();
			},
			refresh_view_edit: async function(d, type) {
				// console.log(d);
				// console.log('编辑更新前', this.parm);

				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {

						if (this.parm[i].type == 'selectnew' || this.parm[i].type == 'select' || this.parm[
								i].type ==
							'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;

							if (String(d.sel_more).indexOf('_to') > 0) {
								let sel_key = String(d.sel_more).substring(0, 1);
								// console.log('编辑联动查询关键字=' + sel_key);

								for (let j = 0; j < this.parm.length; j++) {
									if (this.parm[j].sel_more == sel_key && typeof(this.parm[j]
											.sel_action) !==
										'undefined' && this
										.parm[j].sel_action != '') {

										this.parm[j].list = [];
										this.parm[j].val = '';
										this.parm[j].sel_name = '';

										let res = await this.loadClass(this.parm[j].sel_action, d.val);
										if (res.status == '1') {
											this.parm[j].list = res.data;
										}
										// console.log(this.parm_sel);
										// console.log(this);
										// 强制刷新子组件数据
										this.$refs.editfatherzj[j].refresh_select(JSON.stringify(this.parm[
											j]));
									}
								}
							}

							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}

						break;
					}
				}
				// console.log('编辑更新后', this.parm);

				if (type == 'save') {
					this.fun_upd('add');
				}
			},

			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			refresh_data: function() {
				this.load_list_m();
			},
			load_list_m: function() {
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				let d = [];
				d.push(this.sheet_no);
				this.$post(
					api.http_method, Select_PageLengthMore(this.sel_action, 1, 100, d, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (Number.parseInt(res.data.status) == 1) {
						let arr = res.data.data;
						// console.log(item);
						this.list_wz = [];
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_wz.push(o);
						}
						console.log(this.list_wz);


					} else {
						this.$message({
							message: '没有查询到数据!',
							type: 'warning'
						});
					}
				});
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type);

				if (type == 'upd' || type == 'del' || type == 'sub' || type == 'bad') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}

				// 数据格式检查
				// console.log('检查前', this.parm);
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type ==
							'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[
									i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i]
										.sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[
									i].val) > 0) {
								temp = this.parm[i].val;
							} else if (typeof(this.parm[i].list) !== 'undefined' && this
								.parm[i].list.length > 0) {
								temp = '0';
								let tlist = this.parm[i].list;
								for (let j = 0; j < tlist.length; j++) {
									if (tlist[j].val == this.parm[i].sel_name) {
										temp = tlist[j].id;
									}
								}
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								// console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}


				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].p == '1') {
						d.push(this.parm[i].val);
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_CommonLong('exp30_'+this.upd_action + '_' + type, this.row_id, this
					.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.refresh_data();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			///////////////////////
			fun_d1_upd: function(type, item) {
				// console.log('操作', type);
				// console.log('操作', item);
				this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.fun_d1_sel(item, '_del');
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
				// if (type == '_del') {
				// 	this.fun_d1_sel(item, '_del');
				// }
			},
			fun_d1_sel: function(item, type) {
				// console.log('选择', item);
				for (let d in item) {
					// console.log(d + '=' + item[d]);
					switch (d) {
						case 'id':
							this.row_id = item[d];
							break;
						case 'flag':
							this.sheet_flag = item[d];
							break;
						case 'sys_date':
							this.sys_date = item[d];
							break;
						case 'sheet_no':
							this.sheet_wx = item[d];
							break;
						case 'f_url':
							let tt = JsonStr(item[d]);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[d];
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}

							break;
						case 'f_src':
							this.file_src = item[d];
							break;
						default:
							break;
					}
				}

				for (let d in item) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == d) {
							if (this.parm[j].type == 'select' || this.parm[j]
								.type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[d];
							} else {
								this.parm[j].val = item[d];
							}

						}
					}
				}

				for (var i = 0; i < this.list_wz.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_wz[i].row_num == item.row_num) {
						document.getElementById('tan_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_wz[i].row_num % 2 == 0) {
							document.getElementById('tan_' + this.list_wz[i].row_num).style.background = '#fff';
						} else {
							document.getElementById('tan_' + this.list_wz[i].row_num).style.background = '#f5f5f5';
						}
					}
				}
				if (type == '_del') {
					this.fun_upd('del');
				}

			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);
				// //console.log(item);
				x = that.clientX + 10;
				y = that.clientY - 80;
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" +
					x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// //console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText =
						temp_css;
				}
				if (type == "1" && item != '') {
					temp_css +=
						"max-width: 200px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
					document.getElementById("pre_msg_data_wz").innerText = BackSpecial(
						item);
					document.getElementById("pre_msg_data_wz").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// //console.log('不显示明细');
				document.getElementById("pre_msg_data_wz").style.display = 'none';
			},





		}
	};
</script>


<style scoped>
	.tanfile {
		display: -webkit-inline-box;
		max-height: 60vh;
		overflow: auto;
	}

	.pop_content {

		height: auto;
		/* background: #faf5f5; */
		background-color: rgb(195, 219, 250);
		position: fixed;
		border-radius: 3px;
		display: none;
		z-index: 1000;
		padding: 5px;
		/* overflow: hidden; */

		display: inline-block;
		min-width: 720px;
		max-height: 80vh;
		overflow: auto;
	}

	/* .pop_children{
	position: fixed;
	
	z-index: 9999;
} */
	.tab-row {
		display: inline-block;
		overflow: auto;
	}

	.tab-border {

		display: flex;
		flex-direction: column;
		border: 1px solid #aaa;
		border-radius: 5px;
		margin-bottom: 6px;
	}


	/* 表格//////// */

	.tab-body {
		background-color: #fff;
	}

	.pre_view_tab td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_view_tab td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.edit-body {
		display: flex;
	}

	.edit-row {
		display: flex;
		width: 100%;
	}
</style>